import type { Boletim } from '@/domain/model/Boletim';
import type { GetBoletimUseCase } from '@/application/port/in/GetBoletimUseCase';
import type { BoletimGateway } from '@/application/port/out/BoletimGateway';

export class GetBoletim implements GetBoletimUseCase {
  constructor(private readonly gateway: BoletimGateway) {}
  execute(matriculaId: string): Promise<Boletim> {
    return this.gateway.fetch(matriculaId);
  }
}
